import { MENU } from "./menuConstant";
import { PERMISSION } from "./permissionConstant";
import { concatPermission } from "../util/permission";

// NOTIFICATION
export const NOTIFICATION_VIEW = concatPermission(MENU.NOTIFICATION_MENU, PERMISSION.VIEW)
export const NOTIFICATION_UPDATE = concatPermission(MENU.NOTIFICATION_MENU, PERMISSION.UPDATE)

// COMPLAINT
export const COMPLAINT_VIEW = concatPermission(MENU.COMPLAINT_MENU, PERMISSION.VIEW)
export const COMPLAINT_CATEGORY_VIEW = concatPermission(MENU.COMPLAINT_CATEGORY_MENU, PERMISSION.VIEW)
export const COMPLAINT_SUB_VIEW = concatPermission(MENU.COMPLAINT_SUB_MENU, PERMISSION.VIEW)

// PRIORITY
export const PRIORITY_VIEW = concatPermission(MENU.PRIORITY_MENU, PERMISSION.VIEW)

// LIST SHIFT
export const LIST_SHIFT_VIEW = concatPermission(MENU.LIST_SHIFT_MENU, PERMISSION.VIEW)

// DISTRIBUTOR
export const DISTRIBUTOR_VIEW = concatPermission(MENU.DISTRIBUTOR_MENU, PERMISSION.VIEW)

// PRINCIPAL
export const PRINCIPAL_VIEW = concatPermission(MENU.PRINCIPAL_MENU, PERMISSION.VIEW)

// NS CODE
export const NS_CODE_VIEW = concatPermission(MENU.NS_CODE_MENU, PERMISSION.VIEW)

// PIC_PRINCIPAL
export const PIC_PRINCIPAL_VIEW = concatPermission(MENU.PIC_PRINCIPAL_MENU, PERMISSION.VIEW)

// CONTACT
export const CONTACT_VIEW = concatPermission(MENU.CONTACT_MENU, PERMISSION.VIEW)

// CHANNEL
export const CHANNEL_VIEW = concatPermission(MENU.CHANNEL_MENU, PERMISSION.VIEW)

// ONLINE / OFFLINE
export const CS_ONLINE_UPDATE = concatPermission(MENU.CS_ONLINE_MENU, PERMISSION.UPDATE)
export const CS_OFFLINE_UPDATE = concatPermission(MENU.CS_OFFLINE_MENU, PERMISSION.UPDATE)

// CS LEVEL
export const CS_LEVEL_VIEW = concatPermission(MENU.CS_LEVEL_MENU, PERMISSION.VIEW)

// CSO
export const CSO_VIEW = concatPermission(MENU.CSO_MENU, PERMISSION.VIEW)

// FORCE LOGOUT
export const FORCE_LOG_OUT_DESKTOP_VIEW = concatPermission(MENU.FORCE_LOG_OUT_DESKTOP_MENU, PERMISSION.VIEW)

// TOTAL CS ONLINE
export const TOTAL_CS_ONLINE_MANAGER_VIEW = concatPermission(MENU.TOTAL_CS_ONLINE_MANAGER_MENU, PERMISSION.VIEW)
export const TOTAL_CS_ONLINE_LEAD_VIEW = concatPermission(MENU.TOTAL_CS_ONLINE_LEAD_MENU, PERMISSION.VIEW)

// PROFILE
export const PROFILE_USER_VIEW = concatPermission(MENU.PROFILE_USER_MENU, PERMISSION.VIEW)
export const PROFILE_CHANGE_PASSWORD_UPDATE = concatPermission(MENU.PROFILE_CHANGE_PASSWORD_MENU, PERMISSION.UPDATE)
export const PROFILE_CHANGE_PROFILE_UPDATE = concatPermission(MENU.PROFILE_CHANGE_PROFILE_MENU, PERMISSION.UPDATE)

// DASHBOARD
export const DASHBOARD_VIEW = concatPermission(MENU.DASHBOARD_MENU, PERMISSION.VIEW)
export const DASHBOARD_PRINCIPAL_VIEW = concatPermission(MENU.DASHBOARD_PRINCIPAL_MENU, PERMISSION.VIEW)
export const DASHBOARD_MANAGER_VIEW = concatPermission(MENU.DASHBOARD_MANAGER_MENU, PERMISSION.VIEW)
export const DASHBOARD_LEAD_VIEW = concatPermission(MENU.DASHBOARD_LEAD_MENU, PERMISSION.VIEW)
export const DASHBOARD_CSO_VIEW = concatPermission(MENU.DASHBOARD_CSO_MENU, PERMISSION.VIEW)

// TICKET
export const TICKET_RELATED_VIEW = concatPermission(MENU.TICKET_RELATED_MENU, PERMISSION.VIEW)

// TICKET LIST ALL
export const TICKET_LIST_ALL_VIEW = concatPermission(MENU.TICKET_LIST_ALL_MENU, PERMISSION.VIEW)
export const TICKET_LIST_ALL_DELETE = concatPermission(MENU.TICKET_LIST_ALL_MENU, PERMISSION.DELETE)
export const TICKET_LIST_ALL_VIEW_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_MENU, PERMISSION.VIEW_ASSIGNEE)
export const TICKET_LIST_ALL_OPEN_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_OPEN_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_OPEN_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_OPEN_MENU, PERMISSION.UPDATE_ASSIGNEE)

// TICKET LIST ALL DETAIL
export const TICKET_LIST_ALL_NOTE_INSERT = concatPermission(MENU.TICKET_LIST_ALL_NOTE_MENU, PERMISSION.INSERT)
export const TICKET_LIST_ALL_NOTE_INSERT_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_NOTE_MENU, PERMISSION.INSERT_ASSIGNEE)
// export const TICKET_LIST_ALL_ATTACHMENT_VIEW = concatPermission(MENU.TICKET_LIST_ALL_ATTACHMENT_MENU, PERMISSION.VIEW)
// export const TICKET_LIST_ALL_ATTACHMENT_VIEW_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_ATTACHMENT_MENU, PERMISSION.VIEW_ASSIGNEE)
export const TICKET_LIST_ALL_ISSUE_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_ISSUE_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_ISSUE_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_ISSUE_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_ESCALATE_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_ESCALATE_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_CLOSE_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_CLOSE_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_URL_LINK_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_URL_LINK_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_URL_LINK_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_URL_LINK_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_RELEASE_VERSION_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_RELEASE_VERSION_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_RELEASE_VERSION_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_RELEASE_VERSION_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_REDMINE_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_REDMINE_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_REDMINE_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_REDMINE_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_CUSTOMER_NAME_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_CUSTOMER_NAME_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_CUSTOMER_NAME_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_CUSTOMER_NAME_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_ROOT_CAUSE_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_ROOT_CAUSE_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_ROOT_CAUSE_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_ROOT_CAUSE_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE = concatPermission(MENU.TICKET_LIST_ALL_ISSUE_CATEGORY_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_ALL_ISSUE_CATEGORY_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_ISSUE_CATEGORY_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_REOPEN_UPDATE_ASSGINEE = concatPermission(MENU.TICKET_LIST_ALL_REOPEN_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_ALL_CONTACT_INSERT = concatPermission(MENU.TICKET_LIST_ALL_CONTACT_MENU, PERMISSION.INSERT)
export const TICKET_LIST_ALL_CONTACT_INSERT_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_CONTACT_MENU, PERMISSION.INSERT_ASSIGNEE)

// TICKET LIST NEW
export const TICKET_LIST_NEW_VIEW = concatPermission(MENU.TICKET_LIST_NEW_MENU, PERMISSION.VIEW)
export const TICKET_LIST_NEW_MANAGER_VIEW = concatPermission(MENU.TICKET_LIST_NEW_MANAGER_MENU, PERMISSION.VIEW)
export const TICKET_LIST_NEW_MANAGER_ASSIGN_UPDATE = concatPermission(MENU.TICKET_LIST_NEW_MANAGER_ASSIGN_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_NEW_CSO_VIEW = concatPermission(MENU.TICKET_LIST_NEW_CSO_MENU, PERMISSION.VIEW)
export const TICKET_LIST_NEW_CSO_GRAB_UPDATE = concatPermission(MENU.TICKET_LIST_NEW_CSO_GRAB_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_NEW_ESCALATED_UPDATE = concatPermission(MENU.TICKET_LIST_NEW_ESCALATED_MENU, PERMISSION.UPDATE)

// TICKET LIST MEMBER
export const TICKET_LIST_MEMBER_VIEW = concatPermission(MENU.TICKET_LIST_MEMBER_MENU, PERMISSION.VIEW)

// TICKET LIST SOLUTION
export const TICKET_LIST_SOLUTION_VIEW = concatPermission(MENU.TICKET_LIST_SOLUTION_MENU, PERMISSION.VIEW)

// TICKET LIST SOLUTION DETAIL
export const TICKET_LIST_SOLUTION_RELEASE_VERSION_UPDATE = concatPermission(MENU.TICKET_LIST_SOLUTION_RELEASE_VERSION_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_SOLUTION_RELEASE_VERSION_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_SOLUTION_RELEASE_VERSION_MENU, PERMISSION.UPDATE_ASSIGNEE)
export const TICKET_LIST_SOLUTION_REDMINE_UPDATE = concatPermission(MENU.TICKET_LIST_SOLUTION_REDMINE_MENU, PERMISSION.UPDATE)
export const TICKET_LIST_SOLUTION_REDMINE_UPDATE_ASSIGNEE = concatPermission(MENU.TICKET_LIST_SOLUTION_REDMINE_MENU, PERMISSION.UPDATE_ASSIGNEE)

// TICKET CREATE
export const TICKET_CREATE_INSERT = concatPermission(MENU.TICKET_CREATE_MENU, PERMISSION.INSERT)
export const TICKET_CREATE_ATTACHMENT_INSERT = concatPermission(MENU.TICKET_CREATE_ATTACHMENT_MENU, PERMISSION.INSERT)

// CONTACT
export const CONTACT_LIST_VIEW = concatPermission(MENU.CONTACT_LIST_MENU, PERMISSION.VIEW)
export const CONTACT_LIST_INSERT = concatPermission(MENU.CONTACT_LIST_MENU, PERMISSION.INSERT)
export const CONTACT_LIST_UPDATE = concatPermission(MENU.CONTACT_LIST_MENU, PERMISSION.UPDATE)

// REPORT TICKET PRINCIPAL
export const PRINCIPAL_TICKET_REPORT_VIEW = concatPermission(MENU.PRINCIPAL_TICKET_REPORT_MENU, PERMISSION.VIEW)
export const PRINCIPAL_TICKET_REPORT_VIEW_OWN = concatPermission(MENU.PRINCIPAL_TICKET_REPORT_MENU, PERMISSION.VIEW_OWN)
export const PRINCIPAL_TICKET_REPORT_INSERT = concatPermission(MENU.PRINCIPAL_TICKET_REPORT_MENU, PERMISSION.INSERT)
export const PRINCIPAL_TICKET_REPORT_EXPORT_FILE_VIEW = concatPermission(MENU.PRINCIPAL_TICKET_REPORT_EXPORT_FILE_MENU, PERMISSION.VIEW)
export const PRINCIPAL_TICKET_REPORT_SEND_FILE_VIEW = concatPermission(MENU.PRINCIPAL_TICKET_REPORT_SEND_FILE_MENU, PERMISSION.VIEW)

// EXPORT TICKET
export const EXPORT_TICKET_VIEW = concatPermission(MENU.EXPORT_TICKET_MENU, PERMISSION.VIEW)
export const EXPORT_TICKET_INSERT = concatPermission(MENU.EXPORT_TICKET_MENU, PERMISSION.INSERT)
export const EXPORT_TICKET_PROFILE_UPDATE = concatPermission(MENU.EXPORT_TICKET_PROFILE_MENU, PERMISSION.UPDATE)

// SETTINGS
export const SETTING_CS_AGENT_VIEW = concatPermission(MENU.SETTING_CS_AGENT_MENU, PERMISSION.VIEW)
export const SETTING_CS_AGENT_INSERT = concatPermission(MENU.SETTING_CS_AGENT_MENU, PERMISSION.INSERT)
export const SETTING_PARAMETER_VIEW = concatPermission(MENU.SETTING_PARAMETER_MENU, PERMISSION.VIEW)
export const SETTING_PARAMETER_UPDATE = concatPermission(MENU.SETTING_PARAMETER_MENU, PERMISSION.UPDATE)
export const SETTING_CHATBOT_FLOW_VIEW = concatPermission(MENU.SETTING_CHATBOT_FLOW_MENU, PERMISSION.VIEW)
export const SETTING_CHATBOT_FLOW_INSERT = concatPermission(MENU.SETTING_CHATBOT_FLOW_MENU, PERMISSION.INSERT)
export const SETTING_CHATBOT_FLOW_UPDATE = concatPermission(MENU.SETTING_CHATBOT_FLOW_MENU, PERMISSION.UPDATE)
export const SETTING_CHATBOT_FLOW_DELETE = concatPermission(MENU.SETTING_CHATBOT_FLOW_MENU, PERMISSION.DELETE)
export const SETTING_KMS_VIEW = concatPermission(MENU.SETTING_KMS_MENU, PERMISSION.VIEW)
export const SETTING_KMS_INSERT = concatPermission(MENU.SETTING_KMS_MENU, PERMISSION.INSERT)
export const SETTING_KMS_UPDATE = concatPermission(MENU.SETTING_KMS_MENU, PERMISSION.UPDATE)
export const SETTING_KMS_DELETE = concatPermission(MENU.SETTING_KMS_MENU, PERMISSION.DELETE)
export const SETTING_JOB_PROCESS_VIEW = concatPermission(MENU.SETTING_JOB_PROCESS_MENU, PERMISSION.VIEW)
export const SETTING_LOGIN_HISTORY_VIEW = concatPermission(MENU.SETTING_LOGIN_HISTORY_MENU, PERMISSION.VIEW)
export const SETTING_QUEUE_VIEW = concatPermission(MENU.SETTING_QUEUE_MENU, PERMISSION.VIEW)
export const SETTING_SESSION_VIEW = concatPermission(MENU.SETTING_SESSION_MENU, PERMISSION.VIEW)
export const SETTING_SESSION_UPDATE = concatPermission(MENU.SETTING_SESSION_MENU, PERMISSION.UPDATE)
export const SETTING_ISSUE_CATEGORY_VIEW = concatPermission(MENU.SETTING_ISSUE_CATEGORY_MENU, PERMISSION.VIEW)
export const SETTING_ISSUE_CATEGORY_INSERT = concatPermission(MENU.SETTING_ISSUE_CATEGORY_MENU, PERMISSION.INSERT)
export const SETTING_ISSUE_CATEGORY_UPDATE = concatPermission(MENU.SETTING_ISSUE_CATEGORY_MENU, PERMISSION.UPDATE)
export const SETTING_ISSUE_CATEGORY_DELETE = concatPermission(MENU.SETTING_ISSUE_CATEGORY_MENU, PERMISSION.DELETE)
export const SETTING_COMMISSION_VIEW = concatPermission(MENU.SETTING_COMMISSION_MENU, PERMISSION.VIEW)
export const SETTING_COMMISSION_INSERT = concatPermission(MENU.SETTING_COMMISSION_MENU, PERMISSION.INSERT)
export const SETTING_CALL_HISTORY_VIEW = concatPermission(MENU.SETTING_CALL_HISTORY_MENU, PERMISSION.VIEW)
export const SETTING_CALL_HISTORY_VIEW_ASSIGNEE = concatPermission(MENU.SETTING_CALL_HISTORY_MENU, PERMISSION.VIEW_ASSIGNEE)

// MASTER DATA
export const MASTER_DATA_ROLE_VIEW = concatPermission(MENU.MASTER_DATA_ROLE_MENU, PERMISSION.VIEW)
export const MASTER_DATA_ROLE_INSERT = concatPermission(MENU.MASTER_DATA_ROLE_MENU, PERMISSION.INSERT)
export const MASTER_DATA_ROLE_UPDATE = concatPermission(MENU.MASTER_DATA_ROLE_MENU, PERMISSION.UPDATE)
export const MASTER_DATA_ROLE_DELETE = concatPermission(MENU.MASTER_DATA_ROLE_MENU, PERMISSION.DELETE)
export const MASTER_DATA_DATA_GROUP_VIEW = concatPermission(MENU.MASTER_DATA_DATA_GROUP_MENU, PERMISSION.VIEW)
export const MASTER_DATA_DATA_GROUP_INSERT = concatPermission(MENU.MASTER_DATA_DATA_GROUP_MENU, PERMISSION.INSERT)
export const MASTER_DATA_DATA_GROUP_UPDATE = concatPermission(MENU.MASTER_DATA_DATA_GROUP_MENU, PERMISSION.UPDATE)
export const MASTER_DATA_DATA_GROUP_DELETE = concatPermission(MENU.MASTER_DATA_DATA_GROUP_MENU, PERMISSION.DELETE)
export const MASTER_DATA_USER_VIEW = concatPermission(MENU.MASTER_DATA_USER_MENU, PERMISSION.VIEW)
export const MASTER_DATA_USER_INSERT = concatPermission(MENU.MASTER_DATA_USER_MENU, PERMISSION.INSERT)
export const MASTER_DATA_USER_UPDATE = concatPermission(MENU.MASTER_DATA_USER_MENU, PERMISSION.UPDATE)
export const MASTER_DATA_USER_DELETE = concatPermission(MENU.MASTER_DATA_USER_MENU, PERMISSION.DELETE)
export const MASTER_DATA_DATA_CUSTOMER_VIEW = concatPermission(MENU.MASTER_DATA_DATA_CUSTOMER_MENU, PERMISSION.VIEW)
export const MASTER_DATA_DATA_CUSTOMER_INSERT = concatPermission(MENU.MASTER_DATA_DATA_CUSTOMER_MENU, PERMISSION.INSERT)
export const MASTER_DATA_DATA_CUSTOMER_UPDATE = concatPermission(MENU.MASTER_DATA_DATA_CUSTOMER_MENU, PERMISSION.UPDATE)
export const MASTER_DATA_DATA_CUSTOMER_DELETE = concatPermission(MENU.MASTER_DATA_DATA_CUSTOMER_MENU, PERMISSION.DELETE)
export const MASTER_DATA_SHIFT_VIEW = concatPermission(MENU.MASTER_DATA_SHIFT_MENU, PERMISSION.VIEW)
export const MASTER_DATA_SHIFT_INSERT = concatPermission(MENU.MASTER_DATA_SHIFT_MENU, PERMISSION.INSERT)
export const MASTER_DATA_SHIFT_UPDATE = concatPermission(MENU.MASTER_DATA_SHIFT_MENU, PERMISSION.UPDATE)
export const MASTER_DATA_SHIFT_DELETE = concatPermission(MENU.MASTER_DATA_SHIFT_MENU, PERMISSION.DELETE)
export const MASTER_DATA_REMARK_VIEW = concatPermission(MENU.MASTER_DATA_REMARK_MENU, PERMISSION.VIEW)
export const MASTER_DATA_REMARK_INSERT = concatPermission(MENU.MASTER_DATA_REMARK_MENU, PERMISSION.INSERT)
export const MASTER_DATA_REMARK_UPDATE = concatPermission(MENU.MASTER_DATA_REMARK_MENU, PERMISSION.UPDATE)
export const MASTER_DATA_REMARK_DELETE = concatPermission(MENU.MASTER_DATA_REMARK_MENU, PERMISSION.DELETE)
export const MASTER_DATA_IMPORT_VIEW = concatPermission(MENU.MASTER_DATA_IMPORT_MENU, PERMISSION.VIEW)
export const MASTER_DATA_IMPORT_INSERT = concatPermission(MENU.MASTER_DATA_IMPORT_MENU, PERMISSION.INSERT)

// GROCHAT WEBSOCKET
export const TICKET_LIST_ALL_CHAT_INSERT_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_CHAT_MENU, PERMISSION.INSERT_ASSIGNEE)
export const TICKET_LIST_ALL_CHAT_HISTORY_VIEW = concatPermission(MENU.TICKET_LIST_ALL_CHAT_HISTORY_MENU, PERMISSION.VIEW)
export const TICKET_LIST_ALL_CHAT_HISTORY_VIEW_ASSIGNEE = concatPermission(MENU.TICKET_LIST_ALL_CHAT_HISTORY_MENU, PERMISSION.VIEW_ASSIGNEE)
export const TICKET_LIST_SOLUTION_CHAT_HISTORY_VIEW = concatPermission(MENU.TICKET_LIST_SOLUTION_CHAT_HISTORY_MENU, PERMISSION.VIEW)